export default function RejectedFlight($compile,
                                       $templateRequest,
                                       tripAPI,
                                       flightsUtils,
                                       flightFareService,
                                       flightsService,
                                       userService) {
    'ngInject';

    const activeTemplateUrl = 'app/modules/trip/directives/templates/tripDetails/rejectedFlights.tmpl.html';
    const passiveTemplate = '<div ng-click="openRejectedFlight()" class="rejected-link"><l10n>Rejected flight itineraries</l10n></div>';

    return {
        restrict: 'A',
        template: passiveTemplate,
        transclude: true,
        scope: {
            originalFlights: '=',
            travellers: '=',
        },
        controller: RejectFlightsController,
        link: linkFn,
    };

    function linkFn(scope, element) {

        scope.isTrain = flightsUtils.isItemTrain;
        scope.flightFareService = flightFareService;
        scope.rejectedFlightLoader = rejectedFlightLoader;
        scope.closeRejectedFlight = closeRejectedFlight;
        scope.openRejectedFlight = openRejectedFlight;
        scope.composeCompanyLogoUrl = flightsService.getFlightSupplierLogo;
        scope.regionalSettings = userService.getRegionalSettings();
        scope.rejectedFlightLoader(scope.flights[0].Id, 0);

        function openRejectedFlight() {
            $templateRequest(activeTemplateUrl).then(function(html) {
                uploadTemplate(html);
            });
        }

        function closeRejectedFlight() {
            uploadTemplate(passiveTemplate);
        }

        function rejectedFlightLoader(flightId, flightIndex) {
            const currentFlight = scope.flights[flightIndex];

            if (currentFlight.isShowRejectedFlights) {
                scope.flights[flightIndex].isShowRejectedFlights = false;

                return null;
            }

            if (currentFlight.cheaperFlight) {

                scope.flights[flightIndex].isShowRejectedFlights = true;

                return null;
            }

            if (currentFlight.IsCheapest) {
                //todo: handle empty flights

                return null;
            }

            tripAPI.getRejectedFlight(flightId).then(function(response) {
                const flights = response.data;

                flights.Item2.forEach(function(flight) {
                    flight.FlightSegments.forEach(function(segment) {

                        if (segment.FlightGroups.length > 1) {
                            flight.hasAlternatives = true;
                        }

                        segment.FlightGroups.forEach(function(group) {
                            group.daysShift = flightsUtils.getFlightGroupsDaysShift(group);
                        });
                    });
                });
                scope.flights[flightIndex].cheaperFlight = flights;
                scope.flights[flightIndex].isShowRejectedFlights = true;
            });
        }

        function uploadTemplate(tmpl) {
            element.html(tmpl).show();

            $compile(element.contents())(scope);
        }
    }
}

export function RejectFlightsController(
    $scope,
    l10nService,
    flightsUtils,
    tripUtils,
    moment,
) {
    'ngInject';
    $scope.selectedFlights = {};

    $scope.flights = _.filter($scope.originalFlights, function(flight) {
        return !flight.IsCheapest;
    });

    $scope.l10n = l10nService;
    $scope.lastFlight = flightsUtils.lastFlightDetector;
    $scope.lastFlight = flightsUtils.lastFlight;
    $scope.flightType = flightsUtils.flightType;
    $scope.collectAllCities = flightsUtils.collectAllCities;
    $scope.selectTimeAlternative = selectTimeAlternative;
    $scope.prepareRulesLinkForRejectedFlights = prepareRulesLinkForRejectedFlights;
    $scope.generateRulesParameters = tripUtils.generateRulesParameters;
    $scope.getFlightOrTrain = flightsUtils.getFlightOrTrain;
    $scope.moment = moment;

    function prepareRulesLinkForRejectedFlights(originalFlightIndex, rejectedFlightIndex, fareId) {
        const flight = $scope.flights[originalFlightIndex].cheaperFlight.Item2[rejectedFlightIndex];
        const searchId = $scope.flights[originalFlightIndex].cheaperFlight.Item1;
        const flightGroupIndexes = $scope.selectedFlights[rejectedFlightIndex];

        return flightsUtils.prepareRulesLink(flight, fareId, flightGroupIndexes, $scope.travellers, searchId);
    }

    function selectTimeAlternative(flightIndex, segmentIndex, flightGroupIndex) {
        if (!$scope.selectedFlights[flightIndex]) {
            $scope.selectedFlights[flightIndex] = {};
        }

        $scope.selectedFlights[flightIndex][segmentIndex] = flightGroupIndex;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/rejectedFlights.directive.js